import styled from 'styled-components'
import { Container as BaseContainer } from '@material-ui/core'

export const Container = styled(BaseContainer)`
  background-color: ${props => props.theme.palette.brand.white};
  padding: 0;
`
